import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-12 px-4 sm:px-6 bg-ivory" data-id="element-83">
      <div className="max-w-3xl mx-auto bg-cream border-2 border-gold/40 p-8 sm:p-10 rounded-2xl text-center shadow-lg" data-id="element-84">
        <p className="text-sm font-body font-bold text-sage uppercase tracking-widest mb-4" data-id="element-85">
          YOUR INVESTMENT IS 100% PROTECTED
        </p>
        <div className="w-20 h-20 mx-auto bg-sage/10 rounded-full flex items-center justify-center mb-4 border border-sage/20" data-id="element-86">
          <ShieldCheck className="w-10 h-10 text-sage" data-id="element-87" />
        </div>
        <h3 className="text-2xl sm:text-3xl font-heading font-bold text-petrol mb-2 uppercase leading-tight" data-id="element-88">
          🛡️ 7-Day Total Guarantee
        </h3>
        <p className="text-base sm:text-lg font-subheading font-bold text-petrol mb-4 uppercase tracking-wide" data-id="element-89">
          Your money is 100% protected.
        </p>
        <div className="text-sm sm:text-base text-graphite leading-relaxed max-w-2xl mx-auto" data-id="element-90">
          <p className="mb-3" data-id="element-91">
            You have 7 full days to explore the entire system, review the
            classes, implement the programming, and evaluate the results with
            your participants.
          </p>
          <p className="mb-3" data-id="element-92">
            If you're not completely satisfied, we'll refund 100% of your money.
          </p>
          <p className="font-bold text-petrol" data-id="element-93">Zero risk for you.</p>
        </div>
      </div>
    </section>;
}